import { render } from "./ClientsForm.vue?vue&type=template&id=04b134a7&scoped=true"
import script from "./ClientsForm.vue?vue&type=script&lang=js"
export * from "./ClientsForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b134a7"]])

export default __exports__